import React from "react";
import { Center, Spinner } from "native-base";
import colors from "../../constants/colors";

function RouteFallback() {
  return (
    <Center flex={1} backgroundColor={colors.pageBackground}>
      <Spinner size="lg" color={colors.primary} />
    </Center>
  );
}

export default RouteFallback;
